import React, { useEffect, useState } from "react";
import axios from "axios";
import { AiFillBackward } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import { useGetCategoryQuery } from "../../features/api/categoryApi";
import { useGetWarehouseQuery } from "../../features/api/warehouseApi";
import { API_BASE_URL } from "../../components/baseUrl";

const CreateDamage = () => {
  const [category, setCategory] = useState(null);
  const [SubCategory, setSubCategory] = useState(null);
  const [product, setProduct] = useState(null);
  const [quantity, setQuantity] = useState(null);
  const [warehouse, setWarehouse] = useState(null);

  const { data, isLoading } = useGetCategoryQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const categories = data?.categories;

  const { data: ware, isLoading: wareIsLoading } = useGetWarehouseQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const warehouses = ware?.warehouse;

  const [subCatByCat, setSubCatByCat] = useState([]);
  const [relode, setRelode] = useState(false);
  useEffect(() => {
    fetch(`${API_BASE_URL}/api/sub-categories/${category}`)
      .then((res) => res.json())
      .then((data) => {
        setSubCatByCat(data?.subCategory);
        setRelode(!relode);
      });
  }, [category]);

  // fetch product by Brand name
  const [getProductBySubCat, setGetProductBySubCat] = useState([]);
  useEffect(() => {
    fetch(
      `${API_BASE_URL}/api/subCatProducts?subCategory=${SubCategory}`
    )
      .then((res) => res.json())
      .then((data) => {
        setGetProductBySubCat(data?.product);
        setRelode(!relode);
      });
  }, [SubCategory]);

  const navigate = useNavigate();

  const handleCreate = async () => {
    const data = {
      category: category,
      sub_cat: SubCategory,
      pro_name: product,
      quantity: quantity,
      warehouse: warehouse,
    };
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/damageproduct`,
        data
      );
      if (response) {
        navigate("/dashboard/damageProduct");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-2xl"> Damage Product Quantity Count</h1>
        <Link
          to="/dashboard/damageProduct"
          className="bg-blue-500 px-2 py-1 rounded font-bold text-white flex items-center gap-x-1"
        >
          <AiFillBackward /> Damage Product Management{" "}
        </Link>
      </div>
      <div>
        <form className=" grid grid-cols-2 lg:grid-cols-3  gap-6">
          <div className="flex flex-col gap-1">
            <label>Category</label>
            <select
              onChange={(e) => setCategory(e.target.value)}
              className="border h-8 pl-1"
            >
              <option>--select--</option>
              {categories?.map((category) => (
                <option key={category?.id} value={category?.id}>
                  {category?.cat_name}
                </option>
              ))}
            </select>
          </div>
          <div className="flex flex-col gap-1">
            <label>Brand</label>
            <select
              onChange={(e) => setSubCategory(e.target.value)}
              className="border h-8 pl-1"
            >
              <option>--select--</option>
              {subCatByCat?.map((subCat) => (
                <option key={subCat?.id} value={subCat?.id}>
                  {subCat?.sub_catName}
                </option>
              ))}
            </select>
          </div>
          <div className="flex flex-col gap-1">
            <label>Product</label>
            <select
              onChange={(e) => setProduct(e.target.value)}
              className="border h-8 pl-1"
            >
              <option>--select--</option>
              {getProductBySubCat?.map((product) => (
                <option key={product?.id} value={product?.id}>
                  {product?.product_name}
                </option>
              ))}
            </select>
          </div>
          <div className="flex flex-col gap-1">
            <label>Quantity</label>
            <input
              onChange={(e) => setQuantity(e.target.value)}
              type="number"
              className="border h-8"
            />
          </div>
          <div className="flex flex-col gap-1">
            <label>Warehouse</label>
            <select
              onChange={(e) => setWarehouse(e.target.value)}
              className="border h-8 pl-1"
            >
              <option>--select--</option>
              {warehouses?.map((house) => (
                <option key={house?.id}>{house?.wh_name}</option>
              ))}
            </select>
          </div>
        </form>
        <button
          onClick={handleCreate}
          className="bg-green-500 text-white font-bold px-4 py-1 mt-8 rounded"
        >
          Add
        </button>
      </div>
    </div>
  );
};

export default CreateDamage;
